/**
 * Phase rollout scope (Bill 2026-10-06): which entity categories and product categories
 * FSRs can pick in this phase. Admin Panel settings (System → Settings, category Rollout):
 *   rollout.enabledEntityGroups       — CSV of entity-group keys (personal, business, trust,
 *                                        special-purpose, fiduciary, charitable, government)
 *   rollout.enabledProductCategories  — CSV of product-category keys (checking, savings,
 *                                        certificates, iras, sdb)
 * '*' or a missing setting = everything enabled. Anything not listed shows greyed "Coming soon".
 */
export const SETTING_ENABLED_ENTITY_GROUPS = 'rollout.enabledEntityGroups';
export const SETTING_ENABLED_PRODUCT_CATEGORIES = 'rollout.enabledProductCategories';

export function rolloutAllows(raw: unknown, key: string): boolean {
  if (typeof raw !== 'string') return true;
  const list = raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  if (list.length === 0 || list.includes('*')) return true;
  return list.includes(key.toLowerCase());
}

/**
 * rollout.disabledDisplay — how out-of-phase entity categories, product categories and
 * products appear: 'hidden' (left out entirely) or 'visible' (greyed "Coming soon").
 * Peter (via Bill 2026-10-06): users must not think they can click them → 'hidden'.
 * Products greyed for a cart-eligibility reason (e.g. Minor Savings with no minor) are
 * not affected — they stay greyed with the reason.
 */
export const SETTING_DISABLED_DISPLAY = 'rollout.disabledDisplay';

export function rolloutHidesDisabled(raw: unknown): boolean {
  return typeof raw === 'string' && raw.trim().toLowerCase() === 'hidden';
}
